import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
import { useCanIEditPrescriptions } from './useCanIEditPrescriptions';
export var usePrescriptionsUrl = function (memberUserId, appointmentId) {
    var axios = useAxios();
    var canIEditPrescriptions = useCanIEditPrescriptions();
    return useQuery(['erx-prescriptions-url', memberUserId, appointmentId], function () {
        return axios.get("/api/v1/erx/iframe/prescribing?member_user_id=".concat(memberUserId) +
            (appointmentId ? "&appointment_id=".concat(appointmentId) : ''));
    }, {
        select: function (response) { var _a; return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data; },
        enabled: !!memberUserId && canIEditPrescriptions,
    });
};
